import { render, staticRenderFns } from "./DatepickerDefault.vue?vue&type=template&id=3a87a18f&"
import script from "./DatepickerDefault.vue?vue&type=script&lang=js&"
export * from "./DatepickerDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports